/**
 * Compares names as a reader would: case, spacing and a legal-form suffix
 * ("Med Mera Bygg" and "Med Mera Bygg AB") do not make them different. Used
 * so an invitation never reads "av X från X" (ClickUp 869fj4pqb). Mirrors
 * `sameDisplayName` in etappio-api's invitation mail.
 */
export function sameDisplayName(a: string | null | undefined, b: string | null | undefined): boolean {
  const normalise = (value: string | null | undefined) =>
    (value ?? '')
      .toLocaleLowerCase('sv-SE')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\s+(ab|hb|kb|aktiebolag|handelsbolag|kommanditbolag)$/u, '');
  const left = normalise(a);
  return left !== '' && left === normalise(b);
}
